import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PrimengSharedModule } from '@app/shared/primeng/primeng-shared/primeng-shared.module';
import { ConductorService } from '@app/core/services/conductor.service';
import { TipoLicConductor } from '@app/models/tipo-lic-conductor';
import { NivelMD } from '@app/models/nivel-md';
import { Usuario } from '@app/models/usuario';
import { Conductor } from '@app/models/conductor';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-conductor-form',
    standalone: false,
    templateUrl: './conductor-form.component.html',
    styleUrl: './conductor-form.component.scss'
})
export class ConductorFormComponent {
    private readonly config = inject(DynamicDialogConfig);
    private readonly ref = inject(DynamicDialogRef);
    private readonly service = inject(ConductorService);

    usuario: Usuario = this.config.data?.usuario || {};
    conductor: Partial<Conductor> = {};

    opcionesSelect: { tipoLicencia: TipoLicConductor[]; tipoConducir: TipoLicConductor[]; nivelMd: NivelMD[] } = {
        tipoLicencia: [],
        tipoConducir: [],
        nivelMd: []
    };

    async ngOnInit() {
        const { tipoConducir, tipoLicencia, nivel } = await firstValueFrom(this.service.initForm());

        this.opcionesSelect.tipoConducir = tipoConducir;
        this.opcionesSelect.tipoLicencia = tipoLicencia;
        this.opcionesSelect.nivelMd = nivel;

        if (this.usuario) {
            this.service.getOne(this.usuario.id).subscribe((data) => {
                this.form.patchValue({
                    ...data,
                    vencimiento_licencia: data.vencimiento_licencia ? new Date(data.vencimiento_licencia) : null,
                    licencia_tipo: this.opcionesSelect.tipoLicencia.find((tipo) => tipo.id == data.licencia_tipo?.id),
                    tipo: this.opcionesSelect.tipoConducir.find((t) => t.id == data.tipo?.id),
                    md_nivel: this.opcionesSelect.nivelMd.find((m) => m.id == data.md_nivel?.id)
                });
            });
        }
    }

    form = new FormGroup({
        id: new FormControl(''),
        nro_licencia: new FormControl(this.conductor.nro_licencia, [Validators.required]),
        licencia_tipo: new FormControl(this.conductor.licencia_tipo, [Validators.required]),
        vencimiento_licencia: new FormControl(this.conductor.vencimiento_licencia, [Validators.required]),
        llave: new FormControl(this.conductor.llave),
        tipo: new FormControl(this.conductor.tipo),
        md_nivel: new FormControl(this.conductor.md_nivel)
    });

    actualizar() {
        if (!this.form.valid) return;

        const conductor: Partial<Conductor> = {
            id: this.form.value.id!,
            nro_licencia: this.form.value.nro_licencia!,
            licencia_tipo: this.form.value.licencia_tipo?.id as any,
            vencimiento_licencia: this.form.value.vencimiento_licencia!,
            llave: this.form.value.llave!,
            tipo: this.form.value.tipo?.id as any,
            md_nivel: this.form.value.md_nivel?.id as any
        };
        if (conductor.id)
            this.service.update(conductor).subscribe({
                next: (data) => {
                    this.ref.close();
                },
                error: (err) => {
                    console.error(err);
                }
            });
        else {
            const { id: _, ...data } = conductor;
            this.service.insert({ ...data, usuario: { id: this.usuario.id } }).subscribe({
                next: (data) => {
                    this.ref.close();
                },
                error: (err) => {
                    console.error(err);
                }
            });
        }
    }

    // DEVUELVE SIN ACTUALIZAR
    cancelar() {
        this.ref.close();
    }
}
